// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ob-z","fullWidth":"Pb-z","heading":"Qb-z","fullBleed":"Rb-z","hidden":"Sb-z"};